import { render } from "./TablePagination.vue?vue&type=template&id=282e0b1c"
import script from "./table_pagination.js?vue&type=script&lang=js&external"
export * from "./table_pagination.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__